import script from "./InteractiveMessageBuilder.vue?vue&type=script&lang=ts&setup=true"
export * from "./InteractiveMessageBuilder.vue?vue&type=script&lang=ts&setup=true"

import "./InteractiveMessageBuilder.vue?vue&type=style&index=0&id=0c2043cb&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c2043cb"]])

export default __exports__